
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1313Dialog extends Serenity.EntityDialog<Report_1313Row, any> {
        protected getFormKey() { return Report_1313Form.formKey; }
        protected getIdProperty() { return Report_1313Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1313Row.localTextPrefix; }
        protected getNameProperty() { return Report_1313Row.nameProperty; }
        protected getService() { return Report_1313Service.baseUrl; }
        protected getDeletePermission() { return Report_1313Row.deletePermission; }
        protected getInsertPermission() { return Report_1313Row.insertPermission; }
        protected getUpdatePermission() { return Report_1313Row.updatePermission; }

        protected form = new Report_1313Form(this.idPrefix);

    }
}